import { useEffect } from 'react';
import { useUserInfos } from '../../hooks/useUserInfos';

const Logout = () => {
  const { handleLogout } = useUserInfos();

  useEffect(() => {
    void handleLogout();
  }, [handleLogout]);

  return null;
};

export default Logout;
